export const defaultValues = {
  name: '',
  email: '',
  phone: '',
};
